<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.missing_features.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.missing_features.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="exploreWorkarounds.iconVariant"
          [title]="exploreWorkarounds.title"
          [subtitle]="exploreWorkarounds.subtitle"
          [incentives]="exploreWorkarounds.incentives"
        >
          <div class="actions">
            <rt-button variant="tertiary" (click)="exploreWorkaroundsAction()">
              <rt-icon name="open-in-new" />
              <span>{{ exploreWorkarounds.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="joinTrainingSession.iconVariant"
          [title]="joinTrainingSession.title"
          [subtitle]="joinTrainingSession.subtitle"
          [incentives]="joinTrainingSession.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              [href]="getTrainingScheduleLink()"
              target="_blank"
              (click)="trackAlternativeEvent('join_training')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ joinTrainingSession.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="makeFeatureSuggestion.iconVariant"
          [title]="makeFeatureSuggestion.title"
          [subtitle]="makeFeatureSuggestion.subtitle"
          [incentives]="makeFeatureSuggestion.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              href="https://feedback.tellent.com/tellent-recruitee"
              target="_blank"
              (click)="trackAlternativeEvent('suggest_feature')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ makeFeatureSuggestion.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
